module.exports = __webpack_public_path__ + "img/rectangulo-gray.7716110f.svg";